import angular from 'angular';
import FbService from './fb.service';

export default angular
  .module('accountsApp.fb', [])
  .service('Fb', FbService)
  .name;



// WEBPACK FOOTER //
// ./client/components/auth/fb/index.js